/* cSpell:disable */
import { FooterColItem } from '@tenants/types/tenant';
import { LOCALE_EXP_REALTY_US_PATHS } from 'types/locales';

/** Shared brokerdisclosure lines for eXp Realty US and In-Service footers. */
export const EXP_REALTY_US_FOOTER_DISCLOSURES: FooterColItem[][] = [
  [
    {
      label: {
        key: '',
        defaultValue: ' ',
      },
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_DMCA_LABEL,
        defaultValue: 'DMCA Notice',
      },
      link: '/dmca',
      target: '_blank',
      isAnchor: true,
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_PROTECTED,
        defaultValue: 'This site is protected by reCAPTCHA and the Google ',
      },
    },
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_PRIVACY_POLICY,
        defaultValue: 'Privacy Policy',
      },
      link: 'https://policies.google.com/privacy',
      target: '_blank',
      isAnchor: true,
    },
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_AND,
        defaultValue: ' and ',
      },
    },
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_TERMS_OF_SERVICE,
        defaultValue: 'Terms of Service',
      },
      link: 'https://policies.google.com/terms',
      target: '_blank',
      isAnchor: true,
    },
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_APPLY,
        defaultValue: ' apply',
      },
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_FAIR_HOUSING_LABEL,
        defaultValue: 'Fair Housing and Reasonable Accommodations',
      },
      link: '/fair-housing-and-reasonable-accommodations',
      target: '_blank',
      isAnchor: true,
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_MLS_COMPLIANCE_LABEL,
        defaultValue: 'MLS Compliance Statements',
      },
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_TEXAS,
        defaultValue: 'Karen Richards - Designated Managing Broker, Broker Operations - TX',
      },
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_TEXAS_BROKERAGE_SERVICES_LABEL,
        defaultValue: 'Texas Real Estate Commission information about brokerage services',
      },
      link: 'https://dtzulyujzhqiu.cloudfront.net/expcorporate377/compliance/tx/entity/377_30621_iabs.pdf',
      isAnchor: true,
      target: '_blank',
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_TEXAS_CONSUMER_PROTECTION_LABEL,
        defaultValue: 'Texas Real Estate Commission Consumer Protection Notice',
      },
      link: 'https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-4-1_1.pdf',
      isAnchor: true,
      target: '_blank',
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_FAIR_HOUSING_LABEL,
        defaultValue: 'eXp Realty® is committed to adhering to the guidelines of The New York State Fair Housing Regulations.',
      },
    },
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_FAIR_HOUSING_NOTICE,
        defaultValue: 'The Fair Housing Notice',
      },
      link: 'https://dos.ny.gov/fair-housing',
      isAnchor: true,
      target: '_blank',
    },
    {
      label: {
        key: '',
        defaultValue: ' →',
      },
      link: 'https://dos.ny.gov/system/files/documents/2021/08/fairhousingnotice.pdf',
      target: '_blank',
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_STANDARDIZED_OPERATING_PROCEDURE_LABEL,
        defaultValue: '*Standardized Operating Procedure for Purchasers of Real Estate Pursuant to Real Property Law 442-H.',
      },
    },
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_FAIR_HOUSING_LEARN_MORE,
        defaultValue: 'Learn More',
      },
      link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
      isAnchor: true,
      target: '_blank',
    },
    {
      label: {
        key: '',
        defaultValue: ' →',
      },
      link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
      target: '_blank',
    },
  ],
  [
    {
      label: {
        key: '',
        defaultValue: ' ',
      },
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_CALIFORNIA,
        defaultValue: 'eXp Realty of California, Inc. | CA DRE# 01878277 | Deborah Penny - Designated Broker',
      },
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_SOUTHERN_CALIFORNIA,
        defaultValue: 'eXp Realty of Southern California, Inc. | CA DRE#01325837 | Jason Crawford – Designated Broker',
      },
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_GREATER_LOS_ANGELES,
        defaultValue: 'eXp Realty of Greater Los Angeles, Inc. | CA DRE# 01240990 | Mike Mendibles - Designated Broker',
      },
    },
  ],
  [
    {
      label: {
        key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_NORTHERN_CALIFORNIA,
        defaultValue: 'eXp Realty of Northern California, Inc. | CA DRE# 01951343 | Ryan Rosas - Designated Broker',
      },
    },
  ],
];
